<script lang="ts" setup>
import { DEFAULT_COST } from "@/enums/chatEnums";
import { useChat } from "@/stores/chat";
import { useGlobalUser } from "@/stores/globalUser";
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    msgId: number;
    unlockCost?: number;
    colorMode: "light" | "auto";
  }>(),
  {
    colorMode: "auto",
    unlockCost: DEFAULT_COST,
  }
);
const isUnlocking = ref(false);
const chatStore = useChat();
const user = useGlobalUser();

const unlockMsg = async () => {
  if (!user.isLogin) {
    user.loginModal.show = true;
    return;
  }
  try {
    isUnlocking.value = true;
    try {
      await user.refreshUser();
      // 1.1 水晶不足
      if (user.user.crystalQuantity < props.unlockCost) {
        chatStore.missCrystalAmount =
          props.unlockCost - user.user.crystalQuantity;
        chatStore.showInsufficientCrystalPopup = true;
        return;
      }
      // 1.2 解锁消息
      await chatStore.payOneChatMessage(props.msgId);
    } catch {
      // 1.3 兜底：API返回水晶不足
      chatStore.showInsufficientCrystalPopup = true;
      return;
    }
    // 2. 自动解锁
    if (isAutoUnlock.value) {
      await user.updateUserApi({
        isAutoPayChatMessage: 1,
      });
    }
    // 3. 刷新crystal
    await user.refreshUser();
  } finally {
    isUnlocking.value = false;
  }
};

const isAutoUnlock = ref(true);
</script>
<template>
  <van-divider class="light-mode" dashed>
    <div
      class="flex gap-1 text-xs md:text-sm divider-text font-bold light-mode"
    >
      <i class="iconfont icon-heart-fill" />
      {{ $t("Chats.unlockEntireMsg") }}
    </div>
  </van-divider>
  <div class="flex justify-end gap-1 items-center">
    <button
      :disabled="isUnlocking"
      class="form-control btn btn-xs md:btn-sm btn-ghost"
    >
      <label class="cursor-pointer label flex gap-2 items-center">
        <input
          v-model="isAutoUnlock"
          class="checkbox checkbox-xs checkbox-error"
          type="checkbox"
        />
        <span
          :class="{
            'text-white': colorMode === 'light',
          }"
          class="label-text text-xs md:text-sm"
        >
          {{ $t("Chats.autoUnlock") }}
        </span>
      </label>
    </button>
    <button
      :disabled="isUnlocking"
      class="btn btn-xs md:btn-sm chat-msg-unlock-btn border-0 hover:border-0 text-white"
      @click="unlockMsg"
    >
      <CrystalIcon />
      {{ unlockCost }}
      <span v-if="isUnlocking" class="loading loading-xs text-white" />
    </button>
  </div>
</template>
<style>
.chat-msg-unlock-btn {
  background-image: var(--colorful-gradient-r);
  background-size: 200% auto;
  transition: 0.5s;
  @apply border-0;
}

.chat-msg-unlock-btn:hover {
  background-image: linear-gradient(
    to left,
    #b24592 0%,
    #f15f79 100%
  ); /* change the direction of the change here */
}

.light-mode {
  --van-divider-border-color: #b24592;
}

.light-mode.divider-text {
  background-image: var(--colorful-gradient-r);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
